import React from "react";
import axios from "axios";
import "../../styles/SignUp.css";
import logo from "../../assets/logo_ciano_50_ciano.png";
import toastStyles from "../../styles/Toast.module.css";

function SignUp(props) {
  async function onSignUp(e) {
    e.preventDefault();

    console.log("E", e.target[0].value, e.target[1].value, e.target[2].value);

    let response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}users`,
      {
        username: e.target[0].value,
        email: e.target[1].value,
        password: e.target[2].value,
      }
    );

    console.log(response.data);
  }

  return (
    <form className="Entry" onSubmit={onSignUp}>
      <div className={toastStyles.signUp}>
        <img src={logo} alt="" className={toastStyles.responsiveImage} />
        finstagram
      </div>
      <h1 style={{ color: "white" }}>SIGN UP</h1>
      <div className="form">
        <label>Username:</label>
        <input type="text" />
      </div>
      <div className="form">
        <label>Email:</label>
        <input type="email" />
      </div>
      <div className="form">
        <label>Password:</label>
        <input type="password" />
      </div>
      <div className="buttons">
        <button type="submit">Sign Up</button>
        <button type="button" onClick={() => props.changeToLogin()}>
          Log In
        </button>
      </div>
    </form>
  );
}

export default SignUp;
